 <template>
  <div class="ui-content" v-loading="loading">
    <div class="ui-box">
      <el-form ref="form" class="ui-box-from-questionnaireDetail" label-position="right" :rules="rules" :model="form" label-width="105px">
        <div class="baseInfo">
          <div class="title flex">
            <div>问卷题目</div>
            <el-button v-if="form.questionnaireSet.tbAcceptType===0" class="ui-tableBox-button export" @click="addQuestionnaires">添加题目</el-button>
          </div>
          <div class="ui-tableList">
            <el-table :data="form.questionnaires" border :max-height="600" style="width: 100%" :header-cell-style="{background: '#F2F6FC',color: '#000000','font-weight': 500,'font-family': 'Microsoft YaHei'}">
              <el-table-column align="center" type="index" width="63" min-width="7.1%" label="序号">
              </el-table-column>
              <el-table-column align="center" prop="tbType" min-width="8.8%" label="题目类型">
                <template slot-scope="{row}">
                  {{typeMap[row.tbType]}}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="tbQuestionnaireName" min-width="33.2%" label="问卷题目" show-overflow-tooltip>
              </el-table-column>
              <el-table-column align="center" prop="tbGoodsName" min-width="29.1%" label="选项" show-overflow-tooltip>
                <template slot-scope="{row}">
                  {{row.tbType===5?'暂无':row.questionnaireOptions.map(i=>i.tbOptionsContent).join('、')}}
                </template>
              </el-table-column>
              <el-table-column align="center" v-if="form.questionnaireSet.tbAcceptType===0" width="200" prop="name" label="操作" min-width="17.3%">
                <template slot-scope="{row}">
                  <el-row>
                    <el-col :span="8">
                      <el-link class="ui-tableList-link" @click="editQuestion(row)">编辑</el-link>
                    </el-col>
                    <el-col :span="8">
                      <el-link class="ui-tableList-link" @click="copyQuestion(row)">复制</el-link>
                    </el-col>
                    <el-col :span="8">
                      <el-link class="ui-tableList-link" @click="delQuestion(row)">删除</el-link>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="baseInfo paddingbottom40" v-if="[2].includes(form.questionnaireSet.tbAuditState)">
          <div class="title flex">
            <div>答卷信息</div>
            <el-button v-if="form.questionnaireSet.tbAcceptType===0" class="ui-tableBox-button export" @click="addQuestionnaires">添加题目</el-button>
          </div>
          <div class="ui-tableList">
            <el-table :data="answerList" border :max-height="600" style="width: 100%" :header-cell-style="{background: '#F2F6FC',color: '#000000','font-weight': 500,'font-family': 'Microsoft YaHei'}">
              <el-table-column align="center" type="index" width="63" min-width="7.1%" label="序号">
              </el-table-column>
              <el-table-column align="center" prop="userName" min-width="8.8%" label="姓名">
              </el-table-column>
              <el-table-column align="center" prop="phone" min-width="8.8%" label="手机号">
              </el-table-column>
              <el-table-column align="center" prop="tbUserType" min-width="8.8%" label="用户类型">
                <template slot-scope="{row}">
                  {{userTypeMap[row.tbUserType]}}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="createTime" min-width="8.8%" label="答题时间">
              </el-table-column>
              <el-table-column align="center" width="200" prop="name" label="操作" min-width="17.3%">
                <template slot-scope="{row}">
                  <el-row>
                    <el-link class="ui-tableList-link" @click="seeAnwser(row)">查看答卷</el-link>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination class="ui-papagination" @size-change="page.pagingSizeChange" @current-change="page.pagingCurrentChange" :total="page.total" :pageSizes="page.pageSizes" :pageSize="page.pageSize" :currentPage="page.currentPage"></pagination>
        </div>
        <div class="baseInfo" v-if="!isSee&&form.questionnaireSet.tbStatus===1&&form.questionnaireSet.tbAuditState===3">
          <div class="title">审核</div>
          <el-form-item label="是否通过：">
            <el-button class="return" @click="updateTbAudit(1)">不通过</el-button>
            <el-button type="primary" class="submit" @click="updateTbAudit(2)">通过</el-button>
          </el-form-item>
          <el-form-item label="理由：">
            <el-input class="width645" type="textarea" :rows="6" v-model="tbAuditFeedback"></el-input>
          </el-form-item>

          <div class="ui-box-questionnaireDetail-button">
            <el-button class="return" @click="returnList">返回列表</el-button>
          </div>
        </div>
        <div class="baseInfo" v-if="isSee&&form.audit&&form.questionnaireSet.tbAuditState===1">
          <div class="title">审核</div>
          <el-form-item label="审核结果：">
            <el-input class="ui-box-from-questionnaireDetail-input width645" v-model="form.audit.tbAuditState" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="理由：">
            <el-input class="width645" type="textarea" :rows="6" v-model="form.audit.tbAuditFeedback" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="审核人员：">
            <el-input class="ui-box-from-questionnaireDetail-input width645" v-model="form.audit.tbAuditStaffName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="审核时间：">
            <el-input class="ui-box-from-questionnaireDetail-input width645" v-model="form.audit.auditTime" :disabled="true"></el-input>
          </el-form-item>
          <div class="ui-box-questionnaireDetail-button">
            <el-button class="return" @click="returnList">返回列表</el-button>
          </div>
        </div>
      </el-form>
      <div class="ui-box-questionnaireDetail-button" v-if="form.questionnaireSet.tbAcceptType===0">
        <el-button class="return" @click="returnList">返回列表</el-button>
        <el-button type="primary" class="return" v-show="pageType!=='see'" @click="save">保存</el-button>
        <el-button type="primary" class="submit" v-show="pageType!=='see'&&form.questionnaireSet.tbStatus===0" @click="publish">发布</el-button>
      </div>
    </div>
    <anwserDialog :dialogVisible.sync="dialogVisible2" :answers.sync="answers"></anwserDialog>
    <statisticDialog :dialogVisible.sync="dialogVisible3" :detailsVo.sync="detailsVo"></statisticDialog>
    <addQuestionnairesDialog :dialogVisible.sync="dialogVisible" :questionnaire.sync="questionnaire" :form.sync="form"></addQuestionnairesDialog>
  </div>
</template>

<script>
import cascaderTree from '@/components/cascaderTree/cascaderTree.vue'
import statisticDialog from '@/components/audit/questionnaire/statisticDialog.vue'
import anwserDialog from '@/components/audit/questionnaire/anwserDialog.vue'
import addQuestionnairesDialog from '@/components/audit/questionnaire/addQuestionnairesDialog.vue'
const files = require.context('/', false, /\.vue$/)
const suffixList = files.id.split(' ')[0].split('/').filter((a, b) => b > 2)
const fileName = 'questionnaireDetail'
const controller = 'questionnaireSet'
const parentName = '问卷列表'
import { mapGetters } from 'vuex'
export default {
  name: `${suffixList.join('')}${fileName}`,
  data () {
    const _this = this
    return {
      hospitalList: [],
      loading: false,
      detailsVo: [],
      answers: [],
      dialogVisible3: false,
      dialogVisible2: false,
      answerList: [],
      questionnaire: {
        tbQuestionnaireName: '',
        tbType: '',
        tbSort: '',
        tbIsMustAnswer: 1,
        questionnaireOptions: []
      },
      page: {
        currentPage: 1, //当前页
        pageSize: 10, //每页记录数
        total: 10,
        pageSizes: [10, 20, 50, 100],
        pagingSizeChange (value) {
          _this.page.currentPage = 1
          _this.page.pageSize = value
          _this.queryAnswerUser()
        },
        pagingCurrentChange (value) {
          _this.page.currentPage = value
          _this.queryAnswerUser()
        }
      },
      dialogVisible: false,
      areaIds: [],
      areaProps: {
        multiple: true,
        value: 'id',
        label: 'areaName',
        children: 'children'
      },
      play: false,
      userTypeMap: {
        1: '孕妈',
        2: '医生',
        3: '助理'
      },
      typeMap: {
        1: '单选题',
        2: '多选题',
        3: '判断题',
        5: '简答题'
      },
      tbAuditFeedback: '',
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: fileName,
      rules: {
        'questionnaireSet.tbTitle': [{ required: true, message: '请输入问卷标题', trigger: 'blur' }],
        'questionnaireSet.tbViceTitle': [{ required: true, message: '请输入问卷副标题', trigger: 'blur' }],
        'questionnaireSet.times': [{ required: true, message: '请选择调查时间', trigger: 'blur' }],
        'questionnaireSet.tbIsMother': [{ required: true, message: '请选择接受对象', validator: _this.validatetbIsMother }],
        'questionnaireSet.areaIds': [{ required: true, message: '请选择接受区域', validator: _this.validateArea }]
      },
      form: {
        questionnaireHospital: [],
        questionnaireAddresses: [],
        questionnaires: [],
        questionnaireSet: {
          times: [],
          areaIds: [],
          hospitalIds: [],
          tbType: 1,
          tbTitle: '',
          tbViceTitle: '',
          tbStartTime: '',
          tbStopTime: '',
          tbAcceptType: 0,
          tbIsMother: 0,
          tbIsDoctor: 0,
          tbIsWorker: 0,
          tbStatus: 0,
          tbFigurePath: '',
          address: []
        }
      }
    }
  },
  computed: {
    isSee () {
      if (Object.keys(this.lastBreadCrumb.length > 0)) {
        if (['查看问卷调查'].includes(this.lastBreadCrumb[this.fileName])) {
          return true
        }
      }
      return false
    },
    pageType () {
      if (Object.keys(this.lastBreadCrumb.length > 0)) {
        if (['问卷调查审核', '查看问卷调查'].includes(this.lastBreadCrumb[this.fileName])) {
          return 'see'
        } else if (['新增问卷调查'].includes(this.lastBreadCrumb[this.fileName])) {
          return 'add'
        } else if (['修改问卷调查'].includes(this.lastBreadCrumb[this.fileName])) {
          return 'edit'
        }
      }
      return 'see'
    },
    ...mapGetters([
      'lastBreadCrumb',
      'refreshPage',
      'areaTree'
    ])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.init()
        this.$store.dispatch('setRefreshPage', false)
      }
    }
  },
  methods: {
    remoteMethod (name) {
      if (name !== '') {
        this.loading = true
        this.$http.get(`/hospital/findList`, { name })
          .then(res => {
            this.loading = false
            if (res.code === 1000) {
              this.hospitalList = res.data
            } else {
              this.$message.error(res.message)
            }
          })
      } else {
        this.hospitalList = []
      }
    },
    initHospitalList (tbIds) {
      this.$http.get(`/hospital/findList`, { tbIds })
        .then(res => {
          this.loading = false
          if (res.code === 1000) {
            this.hospitalList = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    validateArea (rule, value, callback) {
      if (this.form.questionnaireAddresses.length === 0) {
        callback(new Error('请选择接受区域'))
      } else {
        callback()
      }
    },
    validatetbIsMother (rule, value, callback) {
      const { tbIsMother, tbIsDoctor, tbIsWorker } = this.form.questionnaireSet
      if (tbIsMother === 0 && tbIsDoctor === 0 && tbIsWorker === 0) {
        callback(new Error('请选择接受对象'))
      } else {
        callback()
      }
    },
    editQuestion (row) {
      this.questionnaire = row
      this.dialogVisible = true
    },
    copyQuestion (row) {
      this.form.questionnaires = [
        ...this.form.questionnaires.filter(i => i.tbSort < row.tbSort),
        JSON.parse(JSON.stringify(row)),
        ...this.form.questionnaires.filter(i => i.tbSort >= row.tbSort)
      ]
      this.form.questionnaires = this.form.questionnaires.map((i, index) => {
        i.tbSort = index + 1
        return i
      })
    },
    delQuestion (row) {
      this.form.questionnaires = this.form.questionnaires.filter(i => i.tbSort !== row.tbSort).map((i, index) => {
        i.tbSort = index + 1
        return i
      })
    },
    addQuestionnaires () {
      this.questionnaire = {
        tbQuestionnaireName: '',
        tbType: '',
        tbIsMustAnswer: 1,
        tbSort: this.form.questionnaires.length + 1,
        questionnaireOptions: []
      }
      this.dialogVisible = true
    },
    updateTbAudit (type) {
      this.$http.post(`audit/updateTbAudit`, {
        auditId: this.form.audit.tbId,
        type: type,
        tbAuditFeedback: this.tbAuditFeedback
      })
        .then(res => {
          if (res.code === 1000) {
            this.returnList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    clear () {
      this.form = {
        questionnaireHospital: [],
        questionnaireAddresses: [],
        questionnaires: [],
        questionnaireSet: {
          hospitalIds: [],
          times: [],
          areaIds: [],
          tbType: 1,
          tbTitle: '',
          tbViceTitle: '',
          tbStartTime: '',
          tbStopTime: '',
          tbAcceptType: 0,
          tbIsMother: 0,
          tbIsDoctor: 0,
          tbIsWorker: 0,
          tbStatus: 0,
          tbFigurePath: '',
          address: []
        }
      }
    },
    init () {
      if (this.pageType !== 'add') {
        this.getById(this.$route.query.tbId)
      } else {
        this.clear()
      }
    },
    setPhoto (data, filed) {
      if (data[filed]) {
        data[`${filed}Temp`] = data[filed] = data[filed].split(',').map(i => {
          return {
            name: '',
            url: this.setUrlOss(i)
          }
        })
      } else {
        data[`${filed}Temp`] = data[filed] = []
      }
    },
    initForm (form) {
      if (form?.questionnaireSet) {
        form.questionnaireSet.times = [form.questionnaireSet.tbStartTime, form.questionnaireSet.tbStopTime]
        this.areaIds = form.questionnaireAddresses.map(({ tbProvinceId, tbCityId, tbAreaId }) => {
          return [100000, tbProvinceId, tbCityId, tbAreaId]
        })
        form.questionnaireSet.hospitalIds = form.questionnaireHospital.map(i => i.tbHospitalId)
        if (form.questionnaireSet.hospitalIds) {
          this.initHospitalList(form.questionnaireSet.hospitalIds.join(','))
        }
        if (form.questionnaireSet.tbAcceptType !== 0) {
          form.questionnaireSet.tbAcceptType = form.questionnaireSet.tbAcceptType === 1 ? '关注我的孕妈' : '我所在医院的孕妈'
        }
      }
      if (form.audit) {
        form.audit.tbAuditState = form.audit.tbAuditState === 1 ? '未通过' : '已通过'
      }
      return form
    },
    getById (id) {
      this.$http.get(`${controller}/get`, { 'tbId': id })
        .then(res => {
          if (res.code === 1000) {
            this.form = this.initForm(res.data)
            if (this.form.questionnaireSet.tbAuditState === 2) {
              this.queryAnswerUser()
              this.questionnaireStatistics()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    seeAnwser (row) {
      this.answers = row.answers
      this.dialogVisible2 = true
    },
    seeStatistic () {
      this.dialogVisible3 = true
    },
    questionnaireStatistics () {
      this.$http.get(`${controller}/questionnaireStatistics`, { tbId: this.form.questionnaireSet.tbId })
        .then(res => {
          if (res.code === 1000) {
            this.detailsVo = res.data.detailsVo.map(i => {
              i.list = []
              i.activeName = []
              return i
            })
          } else {
            this.$message.error(res.message)
          }
        })
    },
    queryAnswerUser () {
      const seach = {
        tbId: this.form.questionnaireSet.tbId
      }
      seach.page = this.page.currentPage
      seach.size = this.page.pageSize
      this.$http.get(`${controller}/queryAnswerUser`, seach)
        .then(res => {
          if (res.code === 1000) {
            this.answerList = res.data.list
            this.page.total = res.data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    returnList () {
      this.closeTab(this.filePath, parentName, this.fileName, ['', ...suffixList].join('/'), true)
    },
    beforeSave (form) {
      form.questionnaireSet.tbStartTime = form.questionnaireSet.times[0]
      form.questionnaireSet.tbStopTime = form.questionnaireSet.times[1]
      form.questionnaireHospital = []
      form.questionnaireSet.hospitalIds.forEach(i => {
        form.questionnaireHospital.push({
          tbHospitalId: i
        })
      })
      delete form.questionnaireSet.times
      delete form.questionnaireSet.hospitalIds
      if (!form.questionnaireSet.tbPublishTime) {
        delete form.questionnaireSet.tbPublishTime
      }
      if (!form.questionnaireSet.tbFigurePath) {
        delete form.questionnaireSet.tbFigurePath
      }
      return form
    },
    cascaderChange (val) {
      this.form.questionnaireAddresses = []
      if (val.length) {
        const codes = val.map(i => i[i.length - 1])
        const CheckedNodes = this.$refs.cascaderTreeRef.$refs.cascaderRef.getCheckedNodes()
        for (const i of CheckedNodes) {
          if (codes.includes(i.value)) {
            this.form.questionnaireAddresses.push({
              tbProvinceId: i.path[1],
              tbProvince: i.pathLabels[1],
              tbCityId: i.path[2],
              tbCity: i.pathLabels[2],
              tbAreaId: i.path[3],
              tbArea: i.pathLabels[3]
            })
          }
        }
      }
    },
    save () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          form = this.beforeSave(form)
          this.loading = true
          this.$http.post(`${controller}/save`, form, 'json', 500000)
            .then(res => {
              this.loading = false
              if (res.code === 1000) {
                this.$message.success('保存成功')
                this.returnList()
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loading = false
            })
            .findlly(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    publish () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          let form = JSON.parse(JSON.stringify(this.form))
          form = this.beforeSave(form)
          if (form.questionnaireSet.tbId) {
            this.$http.post(`${controller}/publishQuestionnaire`, { tbId: form.questionnaireSet.tbId })
              .then(res => {
                if (res.code === 1000) {
                  this.$message.success('发布成功')
                  this.returnList()
                } else {
                  this.$message.error(res.message)
                }
              })
          } else {
            this.$http.post(`${controller}/save`, form, 'json', 500000)
              .then(res => {
                this.loading = false
                if (res.code === 1000) {
                  this.$http.post(`${controller}/publishQuestionnaire`, { tbId: res.data })
                    .then(res2 => {
                      this.loading = false
                      if (res2.code === 1000) {
                        this.$message.success('发布成功')
                        this.returnList()
                      } else {
                        this.$message.error(res2.message)
                      }
                    })
                } else {
                  this.loading = false
                  this.$message.error(res.message)
                }
              })
          }
        } else {
          return false
        }
      })
    }
  },
  created () {
    this.init()
    if (this.areaTree.length === 0) {
      this.$store.dispatch('getAreaTree', this)
    }
  },
  mounted () {
  },
  destroyed () {
  },
  components: {
    cascaderTree,
    addQuestionnairesDialog,
    anwserDialog,
    statisticDialog
  }
}
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    overflow-x: auto;
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-questionnaireDetail {
      padding-top: 29px;
      .baseInfo {
        width: 100%;
        background: #ffffff;
        border-radius: 2px;
        padding: 30px;
        margin-bottom: 40px;
        &.paddingbottom40 {
          padding-bottom: 40px;
        }
        .title {
          font-size: 27px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 37px;
          padding-bottom: 13px;
          border-bottom: 1px solid #dae9ff;
        }
        .inlineDiv {
          width: 50%;
          display: inline-block;
          vertical-align: top;
        }
        ::v-deep .el-form-item {
          margin-top: 24px;
          margin-bottom: 0;
          .ui-box-tableList-img {
            width: 80px;
            height: 80px;
            background: #d8d8d8;
            display: inline-block;
            vertical-align: top;
          }
          &.inline {
            display: inline-block;
            vertical-align: top;
          }
          &.height-auto {
            ::v-deep .el-form-item__content {
              height: auto;
            }
          }

          ::v-deep .el-form-item__label {
            height: 32px;
            line-height: 32px;
            padding: 0;
            margin: 0;
          }
          ::v-deep .el-form-item__error {
            padding-left: 20px;
          }
          ::v-deep .el-form-item__content {
            height: 100%;
            padding-left: 20px;
            line-height: 32px;
          }
          .ui-box-from-questionnaireDetail-text {
            cursor: pointer;
            line-height: 32px;
            display: inline-block;
            vertical-align: top;
            height: 100%;
            width: 48px;
          }
          .width645 {
            width: 645px;
          }
          .margin40 {
            margin-right: 40px;
          }
          .width761 {
            width: 761px;
          }

          .ui-box-from-questionnaireDetail-input {
            width: 275px;
            height: 32px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            &.width645 {
              width: 645px;
            }
            ::v-deep .el-icon-time,
            ::v-deep .el-icon-arrow-down,
            ::v-deep .el-icon-arrow-up,
            ::v-deep .el-icon-date,
            ::v-deep .el-icon-date,
            ::v-deep .el-range__icon,
            ::v-deep .el-range-separator,
            ::v-deep .el-range-input,
            ::v-deep .el-range__close-icon,
            ::v-deep .el-icon-circle-close,
            ::v-deep .el-icon-arrow-up,
            ::v-deep .el-icon-date,
            ::v-deep .el-input__inner {
              vertical-align: top;
              height: 30px;
              line-height: 30px;
              border: none;
            }
            ::v-deep .el-input__inner::-webkit-outer-spin-button,
          // eslint-disable-next-line no-irregular-whitespace
          ::v-deep .el-input__inner::-webkit-inner-spin-button {
              -webkit-appearance: none;
            }
            ::v-deep .el-input__inner[type="number"] {
              -moz-appearance: textfield;
            }
            ::v-deep .el-input-group__append {
              height: 30px;
              border: none;
              &::-moz-placeholder,
              &::-webkit-input-placeholder,
              &::-ms-input-placeholder {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #cccccc;
              }
            }
            ::v-deep .el-input-group__append {
              padding: 0 15px;
            }
          }
          .ui-box-from-questionnaireDetail-button {
            margin-left: 20px;
            vertical-align: top;
            padding: 8px 32px;
            border-radius: 3px;
            &:focus {
              outline: none;
            }
          }
          .ui-box-from-questionnaireDetail-img {
            cursor: pointer;
            line-height: 32px;
            margin-right: 8px;
          }
          .ui-box-from-questionnaireDetail-text {
            cursor: pointer;
            line-height: 32px;
            display: inline-block;
            vertical-align: middle;
            height: 100%;
            margin-right: 30px;
          }
        }
      }
    }
    .ui-box-questionnaireDetail-button {
      margin-top: 20px;
      margin-left: 84px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
      .submit {
        margin-left: 0;
        padding: 6px 25px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}

.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    overflow-x: auto;
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-questionnaireDetail {
      padding-top: 29px;
      .baseInfo {
        width: 100%;
        background: #ffffff;
        border-radius: 2px;
        padding: 30px;
        margin-bottom: 40px;
        .title {
          font-size: 27px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 37px;
          padding-bottom: 13px;
          border-bottom: 1px solid #dae9ff;
          &.flex {
            display: flex;
            justify-content: space-between;
          }
        }
        .ui-tableList {
          max-height: 60%;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          margin: 20px 0 0;
          ::v-deep .ui-tableList-selection {
            background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAqCAYAAAAu9HJYAAADgElEQVRYR9XYe0yNcRzH8ffRhVIumYiRsoxashbZJCnX4Q8xc1sYZsps/rCIlWuYzeUff9jE+MNclqLNnQnDLDWy1DIMIXeVVHLst5+T0zmn5zznPE+n0/nr7DznOc/r+Xy/39/v2THQCV6GTmCkcyEn5BiN7piq0cCWliT1QkYGwpNqfW5XAAuXGbbqikwbDb7esPeudqQJKH5JN6QAdv8HDO4FL785DzUHakb6eEL9b0gdDX7/gHGDITMBUnLhXa3jUEugJmRXDzg0E4rfga+XLLEAzo2ApmbIvAm/fsOsYXC+HNRMpS2gJqQ4+cA0qGmEzBv/gRuvwa4kWHcZNsXD6+9wrMR+om0BNSFFiYf0khfffw/S4yDjOvxskvhunnD/jXag08gV0RDgI0t8PBmW50PzH2g2QhcDbI6H8EA4+Rjyy5VTVErQdKbq6e7rCw3N8KMBBveUZRR9JkB5z6C0WgJNJT5VCrsnw9XnUFBhG6oG6FCS+6dBdiF8/Nn6gktHwcQQWHcJJoXKITL14NDesHUiLM61RqoFqkZOD4MB/nDkEUwZCh4GuFgpL5w8AqKDoJ8fZFz7fxOiJ/dNhcNFUPK+NdIRoCpkv+6ybCvPQ2IIpI2BhWehrkleeMYwia6qgVUxkH4VvtTLY2LtrG3UBrSLjA+GmgaZntjuRAMXVcH4YNh0Xfao+StmgDXU/LijCSoOTpAfhPWRKYk10MsDNsTBhXJ48BZmhMneyy2TE20JFTfzsEp7gorIE8myfGJCRcnGDIScYtiZBKsLQAzEtkSo+Aw7bllDLcfE2QTbRIoSrx8He+7IJMXAiDQXRMq9uPQDpERB9m04OB3KPilDtQJt9mRSKNQ3waKR8L5Wvh87CFILwN8b1sZK4JpYuT4uiZLfE5/pnaBiuUWJ50XA6aewPRG+1suBEQPUAiyD0AAY1APOlcELi0czPRJURJoOZiXAlUqorrNI0Awo9m3LJxw9gXaXINM6N3s4JITILTHPxUC7SPMeE+UX/Vr4CsQC74oEVZXbchAEdE44zD/T/iU2v7bqpyDTSf395DTrsZNYrwe2P3EY2V7LjBJYE1LvKW4L6jTSVUCHptuVPWiZqMNJujJBp5agjgA6VO6OAqpGdiRQFbKjgXaR7gBURLoLsE2kOwFtIt0NaIV0R2ArZPxRY5b4E13t45Mrv/cXaxXOlUEyqTEAAAAASUVORK5CYII=")
              no-repeat -2px -3px;
          }
          .ui-box-tableList-img {
            width: 80px;
            height: 80px;
            background: #d8d8d8;
            display: inline-block;
            vertical-align: top;
          }
          .labelBox {
            width: 30px;
            height: 20px;
            background: #f7b500;
            border-radius: 2px;
            font-size: 10px;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            display: inline-block;
          }
          .ui-box-tableList-label {
            margin: 0 5px 10px;
          }
          .ui-box-tableList-editImg {
            width: 43px;
            cursor: pointer;
            height: 43px;
          }
          .ui-box-tableList-tempSaveImg {
            width: 41px;
            height: 41px;
            position: absolute;
            left: -2px;
            top: -3px;
          }
          ::v-deep .el-table__body-wrapper {
            height: auto !important;
          }
          .ui-tableList-button {
            padding: 9px 17px;
            outline: none;
          }
        }
        .inlineDiv {
          width: 50%;
          display: inline-block;
          vertical-align: top;
        }
        ::v-deep .el-form-item {
          margin-top: 24px;
          margin-bottom: 0;
          .ui-box-tableList-img {
            width: 80px;
            height: 80px;
            background: #d8d8d8;
            display: inline-block;
            vertical-align: top;
          }
          &.inline {
            display: inline-block;
            vertical-align: top;
          }
          &.height-auto {
            .el-form-item__content {
              height: auto;
            }
          }

          .el-form-item__label {
            height: 32px;
            line-height: 32px;
            padding: 0;
            margin: 0;
          }
          .el-form-item__error {
            padding-left: 20px;
          }
          .el-form-item__content {
            height: 100%;
            padding-left: 20px;
            line-height: 32px;
          }
          .ui-box-from-questionnaireDetail-text {
            cursor: pointer;
            line-height: 32px;
            display: inline-block;
            vertical-align: top;
            height: 100%;
            width: 48px;
          }
          .width645 {
            width: 645px;
          }
          .margin40 {
            margin-right: 40px;
          }
          .width761 {
            width: 761px;
          }

          .ui-box-from-questionnaireDetail-input {
            width: 275px;
            height: 32px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            &.width645 {
              width: 645px;
            }
            .el-icon-time,
            .el-icon-arrow-down,
            .el-icon-arrow-up,
            .el-icon-date,
            .el-icon-date,
            .el-range__icon,
            .el-range-separator,
            .el-range-input,
            .el-icon-circle-close,
            .el-icon-arrow-up,
            .el-icon-date,
            .el-input__inner {
              vertical-align: top;
              height: 30px;
              line-height: 30px;
              border: none;
            }
            .el-input__inner::-webkit-outer-spin-button,
            // eslint-disable-next-line no-irregular-whitespace
            .el-input__inner::-webkit-inner-spin-button {
              -webkit-appearance: none;
            }
            .el-input__inner[type="number"] {
              -moz-appearance: textfield;
            }
            .el-input-group__append {
              height: 30px;
              border: none;
              &::-moz-placeholder,
              &::-webkit-input-placeholder,
              &::-ms-input-placeholder {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #cccccc;
              }
            }
            .el-input-group__append {
              background: #fff;
              border-radius: 0;
              border: none;
              border-left: 1px solid #dcdfe6;
            }
            .el-input-group__append {
              padding: 0 15px;
            }
          }
          .ui-box-from-questionnaireDetail-button {
            margin-left: 20px;
            vertical-align: top;
            padding: 8px 32px;
            border-radius: 3px;
            &:focus {
              outline: none;
            }
          }
          .ui-box-from-questionnaireDetail-img {
            cursor: pointer;
            line-height: 32px;
            margin-right: 8px;
          }
          .ui-box-from-questionnaireDetail-text {
            cursor: pointer;
            line-height: 32px;
            display: inline-block;
            vertical-align: middle;
            height: 100%;
            margin-right: 30px;
          }
        }
      }
    }
    .ui-box-questionnaireDetail-button {
      margin-top: 20px;
      margin-left: 84px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
      .submit {
        margin-left: 0;
        padding: 6px 25px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>